/**
 * Search normalisation for filter-bar and site-search matching:
 *  - accent-insensitive ("Jose" matches "Jos\u00e9"),
 *  - case-insensitive,
 *  - whitespace- and punctuation-insensitive: every non-alphanumeric
 *    character is dropped from both the term and the haystack, so
 *    "kiwa nv", "kiwanv", "ki wanv", "kiwa nv." and even the substring
 *    "iwanv" all match "Kiwa N.V.".
 */
export const normalizeSearchText = value => value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]/g, "");